import cn from 'classnames';
import styles from './LeaveQuestionForm.module.scss';
import { FETCH_METHODS, ProductDetailedType } from '@/types';
import { ModalContentWrapper } from '@/atoms/ModalContentWrapper';
import {
  FormProvider,
  SubmitHandler,
  useForm,
  useWatch,
} from 'react-hook-form';
import { Input } from '@/atoms/Input';
import { MESSAGE_REGEX } from '@/constants';
import { Toggle } from '@/components/Toggle';
import { Button } from '@/atoms/Button';
import { useDispatch } from 'react-redux';
import { setShowLeaveQuestionModal } from '@/store';
import { useState } from 'react';
import { ProductReduced } from '@/components/ProductReduced';
import { SuccessActionContent } from '@/atoms/SuccessActionContent';
import { fetchData } from '@/services';
import toast from 'react-hot-toast';

type LeaveQuestionFormProps = {
  className?: string;
  product: ProductDetailedType;
};

type QuestionFormInputs = {
  question: string;
  anonymous: boolean;
};

export function LeaveQuestionForm({
  className,
  product,
}: LeaveQuestionFormProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    dispatch(setShowLeaveQuestionModal(false));
  };

  const methods = useForm<QuestionFormInputs>();

  const onSubmit: SubmitHandler<QuestionFormInputs> = async (data) => {
    setIsLoading(true);

    const response = await fetchData({
      url: '/form/faq',
      method: FETCH_METHODS.POST,
      body: {
        isAnonymous: data.anonymous,
        question: data.question,
        productId: product.id,
      },
    });

    if (response.success) {
      setSuccess(true);
    } else {
      toast.error('Ошибка при отправке вопроса');
    }

    setIsLoading(false);
  };

  const fields = useWatch({ control: methods.control });

  const handleSubmit = methods.handleSubmit(onSubmit);

  const isDisabled = !fields.question || isLoading;

  if (success) {
    return (
      <SuccessActionContent
        title="Вопрос отправлен"
        buttonText="Вернуться к покупкам"
        onClick={handleClose}
      />
    );
  }
  return (
    <div className={wrapperClassName}>
      <ModalContentWrapper title="Задать вопрос">
        <div className={styles.content}>
          <ProductReduced product={product} />
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit} className={styles.form}>
              <Input
                name="question"
                placeholder="Когда появится в наличии?"
                pattern={MESSAGE_REGEX}
                required
              />
              <Toggle
                label="Анонимно"
                checked={fields.anonymous ?? false}
                onChange={() =>
                  methods.setValue('anonymous', !fields.anonymous)
                }
              />
              <Button
                text="Задать вопрос"
                onClick={() => {}}
                type="submit"
                variant="primary"
                disabled={isDisabled}
              />
            </form>
          </FormProvider>
        </div>
      </ModalContentWrapper>
    </div>
  );
}
